import Slider from "react-slick";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Srcset from "../common/Srcset";
import Image from "next/image";

import ProductImage from "../ProductImage";
import SlickSlider from "../SlickCarousal/index";
import VideoComp from "../VideoComp";

import styles from "../MobileCarousel/MobileCarousel.module.scss";
import { useSelector } from "react-redux";

export default function MobileCarousel({ onRequestClose, productImage}) {
  // filtering out videos (Video to be displayed on Desktop only)
  productImage = productImage.filter((ele) => ele?.type !== "VIDEO");
  // const [isOpen, setIsOpen] = useState(false);
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );
  const menuOpen = useSelector((state) => state.header.isMenuVisible);
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  const [isOpen, setIsOpen] = useState(false);
  // const [isOpen, setIsOpen] = useState(false);
  function toggleModal() {
    setIsOpen(!isOpen);
    document.querySelector("body").classList.toggle("disable-scroll"); //code to prevent background scroll
    document.querySelector("html").classList.toggle("disable-scroll-html");
  }

  //set loader for image for image optimization
  const myLoader = ({ src, width, height, quality }) => {
    return `${src}?w=${width}&h=${height}&q=${quality || 75}`;
  };
  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    prevArrow: false,
    nextArrow: false,
    onInit: () => {
      let loadingDiv = document.querySelector('.for-pdp-loading');
      if(loadingDiv) {
        loadingDiv.classList.remove('loading');
      }
    },
  };
  const slidesData = productImage.slice(0, 6).map((ele, index) => {
    if (ele.type && ele.type === "video") {
      let videoSrc = "";
        Object.values(ele).forEach((src, index) => {
          if (index == 0) {
            videoSrc=src.url;
          }
        })
        return (
          <VideoComp vidSrc={videoSrc} autoPlay={true} thumbnail={false} controls={false} />
        )
    } else {
      return (
        <>
          <Srcset
            loader={myLoader}
            key={index + "images"}
            src={ele.url}
            alt={ele.alt}
            data-title={ele.title}
            width="100%"
            height="100%"
            retinaImage={true}
            className={styles.bg_transparent}
          />
          <span></span>
        </>
      );
    }
  });

  // Fix for shop and account sidebar opening behind the image carousel
  useEffect(()=>{
    if(isPWA && (menuOpen || accountSidebarOpen)){
      if(isOpen){
        toggleModal()
      }
    }
  },[menuOpen,accountSidebarOpen])

  return (
    <>
      <Modal
        isOpen={isOpen}
        contentLabel="My dialog"
        style={{
          content: {
            inset: 0,
            padding: 0,
          },
        }}
      >
        <SlickSlider onRequestClose={toggleModal} productImage={productImage} />
      </Modal>
      <div className="loading for-pdp-loading"></div>
      <Slider {...settings}>
        {slidesData.map((slide, index) => (
          <div key={index}>
            <div className={styles.mobile_image} onClick={!slide.props.vidSrc?toggleModal:""}>
              {slide}
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
}
